<template>
  <div v-if="viewTypeTab === 'desktopViewTab'">
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>Message</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Size & Position</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="banner-config-size">
            <RfInputWithMeasures v-model="widgetWidth" :measures="measures" label="Width" />
            <RfInputWithMeasures v-model="widgetHeight" :measures="measures" label="Height" />
          </div>
          <div class="banner-config-size">
            <RfInputWithMeasures
              v-model="widgetMessageWdth"
              :measures="measures"
              label="Message Width"
            />
            <v-select
              v-model="actions.rf_banner_display"
              variant="outlined"
              hideDetails
              density="compact"
              label="Banner Display"
              :items="bannerDisplayOptions"
              itemTitle="text"
            />
          </div>
          <div class="banner-config-size">
            <v-select
              v-model="horizontalPosition"
              variant="outlined"
              hideDetails
              density="compact"
              label="Widget Horizontal Position"
              :items="Object.values(HorizontalPositions)"
              itemTitle="text"
            />
            <v-select
              v-model="verticalPosition"
              variant="outlined"
              hideDetails
              density="compact"
              label="Widget Vertical Position"
              :items="Object.values(VerticalPositions)"
              itemTitle="text"
            />
          </div>
          <div class="banner-config-size">
            <RfInputWithMeasures
              v-model="xPosOffset"
              :measures="measures"
              :label="offsetXLabel"
              :disabled="offsetXDisabled"
            />
            <RfInputWithMeasures v-model="yPosOffset" :measures="measures" :label="offsetYLabel" />
          </div>
          <div class="banner-config-size">
            <v-checkbox
              v-model="actions.rf_banner_position_reverse"
              label="Reverse direction"
              trueValue="true"
              falseValue="false"
              hideDetails
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>User Interaction</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionButtons :actions="actions" :model="model" showCloseOptions />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Countdown Timer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsCountdown :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Close Timer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsBehavior :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Background</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionImageUpload :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        v-if="
          [
            DefaultDeviceOptions.ios.value,
            DefaultDeviceOptions.tv_os.value,
            DefaultDeviceOptions.roku_os.value,
            DefaultDeviceOptions.android_os.value,
            DefaultDeviceOptions.android_tv.value,
          ].includes(props.model.device_type)
        "
      >
        <v-expansion-panel-title>In-App Purchase</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsInapp :actions="actions" :app="app" :deviceType="model.device_type" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <template
        v-if="
          [
            DefaultDeviceOptions.android_os.value,
            DefaultDeviceOptions.android_tv.value,
            DefaultDeviceOptions.roku_os.value,
            DeviceTypeWording.custom_defined.value,
          ].includes(props.model.device_type)
        "
      >
        <v-expansion-panel>
          <v-expansion-panel-title>Deep Link</v-expansion-panel-title>
          <v-expansion-panel-text class="retention-config-segments">
            <RfRetentionActionsDeeplink :deviceType="model.device_type" :actions="actions" />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </template>
      <v-expansion-panel>
        <v-expansion-panel-title>Device Metadata</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMetadata :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <RfPromoCustomCSS :actions="actions" />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        v-if="model.device_type === DefaultDeviceOptions.web.value && app.flags.paywalls"
      >
        <v-expansion-panel-title>Paywall</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPaywallConfig :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else>
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>CONFIGURATION</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMobileWeb :app="app" :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Size & Position</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="banner-config-size">
            <v-text-field
              v-model.trim="actions.rf_mobile_width"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              hideDetails
              label="Width"
              placeholder="e.g.: 300px"
            />
            <v-text-field
              v-model.trim="actions.rf_mobile_height"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              hideDetails
              label="Height"
              placeholder="e.g.: 300px"
            />
          </div>
          <v-text-field
            v-model.trim="actions.rf_mobile_message_width"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            class="mt-4"
            hideDetails
            label="Message Width"
            placeholder="e.g.: 300px"
          />
          <div class="banner-config-size mt-4">
            <v-select
              v-model="mobileVerticalPosition"
              variant="outlined"
              hideDetails
              density="compact"
              label="Widget Vertical Position"
              :items="Object.values(VerticalPositions)"
              itemTitle="text"
            />
            <v-text-field
              v-model.trim="actions.rf_mobile_banner_position_offset_y"
              hideDetails
              variant="outlined"
              density="compact"
              persistentPlaceholder
              :label="mobileOffsetYLabel"
              required
            ></v-text-field>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="props.model.device_type === DefaultDeviceOptions.web.value">
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPromoCustomCSS :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup>
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";
import RfRetentionButtons from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtons.vue";
import RfRetentionActionsMobileWeb from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMobileWeb.vue";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfRetentionImageUpload from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionImageUpload.vue";
import { computed, ref, watchEffect } from "vue";
import { HorizontalPositions, VerticalPositions } from "@/utils/constants/PositionConstants";
import { getPosition } from "@/utils/prompts/promptHelpers";
import {
  DEFAULT_MEASURES,
  DEVICES_MEASURES,
  ROKU_MEASURES,
  useCSSProperty,
  WEB_MEASURES,
} from "@/utils/composables/useCSSProperty";
import { DefaultDeviceOptions, DeviceTypeWording } from "@/utils/constants/DevicesConstants";
import RfRetentionActionsInapp from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInapp.vue";
import RfRetentionActionsCountdown from "./RfRetentionActionsCountdown.vue";
import RfRetentionActionsDeeplink from "./RfRetentionActionsDeeplink.vue";
import RfRetentionActionsMetadata from "./RfRetentionActionsMetadata.vue";
import RfPaywallConfig from "./RfPaywallConfig.vue";
import RfInputWithMeasures from "@/components/legacy/RfInputWithMeasuresLegacy.vue";

const props = defineProps(["actions", "model", "app", "viewTypeTab"]);
const emit = defineEmits(["updateBannerPosition", "updateMobileBannerPosition"]);

const bannerDisplayOptions = [
  { value: "horizontal", text: "Horizontal" },
  { value: "vertical", text: "Vertical" },
];
const { variable: widgetWidth } = useCSSProperty(() => props.actions, "rf_widget_width");
const { variable: widgetHeight } = useCSSProperty(() => props.actions, "rf_widget_height");
const { variable: widgetMessageWdth } = useCSSProperty(
  () => props.actions,
  "rf_settings_text_container_max_width",
);
const { variable: xPosOffset } = useCSSProperty(() => props.actions, "rf_banner_position_offset_x");
const { variable: yPosOffset } = useCSSProperty(() => props.actions, "rf_banner_position_offset_y");

const measures = computed(() => {
  if (props.model.device_type === DefaultDeviceOptions.roku_os.value) return ROKU_MEASURES;
  if (props.model.device_type === DefaultDeviceOptions.web.value) return WEB_MEASURES;
  if (
    [
      DefaultDeviceOptions.android_os.value,
      DefaultDeviceOptions.android_tv.value,
      DefaultDeviceOptions.ios.value,
      DefaultDeviceOptions.tv_os.value,
    ].includes(props.model.device_type)
  )
    return DEVICES_MEASURES;
  return DEFAULT_MEASURES;
});
const widgetPosition = computed(() => getPosition(props.actions));
const horizontalPosition = ref(widgetPosition.value.x);
const verticalPosition = ref(widgetPosition.value.y);
const mobileWidgetPosition = computed(() => getPosition(props.actions, true));
const mobileVerticalPosition = ref(mobileWidgetPosition.value.y);
const getPromoPanel = ref([0]);

const offsetXLabel = computed(_ => `${HorizontalPositions[widgetPosition.value.x].text} Padding`);
const offsetYLabel = computed(_ => `${VerticalPositions[widgetPosition.value.y].text} Padding`);
const mobileOffsetYLabel = computed(
  () => `${VerticalPositions[mobileWidgetPosition.value.y].text} Padding`,
);
const offsetXDisabled = computed(() =>
  props.actions.rf_widget_position.includes(HorizontalPositions.center.value),
);

watchEffect(() =>
  emit("updateBannerPosition", `${verticalPosition.value}_${horizontalPosition.value}`),
);

watchEffect(() =>
  emit(
    "updateMobileBannerPosition",
    `${mobileVerticalPosition.value}_${HorizontalPositions.center.value}`,
  ),
);
</script>

<style lang="scss">
.banner-config-size {
  display: flex;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
  > div {
    width: 50%;
    padding-right: 10px !important;
    &:last-child {
      padding-right: 0 !important;
    }
  }
}
</style>
